import React from 'react';
// import { Link } from 'react-router-dom';
import CardTemplateComponent from '../CardTemplate';
import { SingleChoicePrePoll, SingleChoicePostPoll } from './SingleChoicePoll';
import { MultiChoicePrePoll, MultiChoicePostPoll } from './MultiChoicePoll';
import { SingleChoiceCarouselPrePoll, SingleChoiceCarouselPostPoll } from './SingleChoiceCarouselPoll';
import { MultiChoiceCarouselPrePoll, MultiChoiceCarouselPostPoll} from './MultiChoiceCarouselPoll';
import { RatingPrePoll, RatingPostPoll } from './RatingPoll';
import {Icon} from '../../Common/Icon';
import { translate } from 'react-i18next';
import cx from '../../../styles';
import {gtmSend} from '../../../helpers';

const PrePoll = {
    1: SingleChoicePrePoll,
    2: SingleChoicePrePoll,
    4: MultiChoicePrePoll,
    5: RatingPrePoll,
    6: MultiChoiceCarouselPrePoll,
    7: SingleChoiceCarouselPrePoll
}

const PostPoll = {
    1: SingleChoicePostPoll,
    2: SingleChoicePostPoll,
    4: MultiChoicePostPoll,
    5: RatingPostPoll,
    6: MultiChoiceCarouselPostPoll,
    7: SingleChoiceCarouselPostPoll
}

const PollCard = ({message, title, images, currentState, totalVotes, votes, pollChoices, viewUrl, inFeed, voteHandler, match, t, pollType, pollTypePlaceholder, id, botIndex, url, contentHub}) => {
    const PrePollState = PrePoll[pollType] || SingleChoicePrePoll, PostPollState = PostPoll[pollType] || SingleChoicePostPoll;
    
    let relValue = {};
    if(!botIndex){
        relValue = {
            rel: "nofollow"
        };
    }

    return (
        <div className={cx("question-elements", "poll-card")}>
            {
                inFeed
                ? 
                    <div className={cx("poll-question", "infeed-question", pollChoices.length > 5 && pollType !== 5 ? 'same-line' : 'separate-line')} onClick={()=> {onContentClick(); gtmSend('dynamic', 'Poll Card', 'click-title-click', match.path)}}>
                        <div className={cx("question-wrapper")}>
                        <a href={`${contentHub? url : `/${viewUrl}`}`} className={cx('page-title')} {...relValue} dangerouslySetInnerHTML={{__html: title}} />
                        <a href={`${contentHub? url : `/${viewUrl}`}`} className={cx('text-desc')} {...relValue} dangerouslySetInnerHTML={{__html: message}} />
                        </div>
                        {
                            images.length > 0 &&
                            <div className={cx("img-wrap")}>
                                <div className={cx("img-blur-wrap")}>
                                    <div style={{backgroundImage:'url('+images[0].thumbnail+')'}}></div>
                                    <img src={images[0].thumbnail} alt={message} loading="lazy" height={images[0].thumb_height} width={images[0].thumb_width} />
                                </div>
                            </div>
                        }
                    </div>
                : 
                    <div className={cx("poll-question", pollChoices.length > 5 && pollType !== 5 ? 'same-line' : 'separate-line')}>
                        <div className={cx("question-wrapper")}>
                            <h1 className={cx('page-title')} dangerouslySetInnerHTML={{__html: title}}></h1>
                            <div className={cx('text-desc')} dangerouslySetInnerHTML={{__html: message}}></div>
                        </div>
                        {
                            images.length > 0 &&
                            <div className={cx("img-wrap")}>
                                <div className={cx("img-blur-wrap")}>
                                    <div style={{backgroundImage:'url('+images[0].thumbnail+')'}}></div>
                                    <img src={images[0].thumbnail} alt={message} loading="lazy" height={images[0].thumb_height} width={images[0].thumb_width} />
                                </div>
                            </div>
                        }
                    </div>
            }

            <div className={cx('type-placeholer-wrap')}>
                { 
                    !currentState 
                    ? 
                        <span className={cx('type-placeholder')}>
                            <span className={cx('voice-icon')}>
                                <Icon name="voice-opinion-icon" />
                            </span>
                            <span>{pollTypePlaceholder}</span>
                        </span>
                    : 
                        <span className={cx('response-recorded')}>
                            <span className={cx('check')}></span>
                            <span>{t('response_recorded')}</span>
                        </span>
                }
            </div>

            <div className={cx("poll-state-wrap")}>
                { !currentState ? <PrePollState pollChoices={pollChoices} id={id} t={t} voteHandler={voteHandler} match={match}/> : <PostPollState votes={votes} voteHandler={voteHandler} t={t} /> }
            </div>

            <div className={cx("voters-wrap")}>
                <p>{totalVotes} {totalVotes > 1 ? t('poll_responses') : t('poll_response')}</p>
            </div>
        </div>
    )
}

const PollCardComponent = CardTemplateComponent(PollCard);

export default translate()(PollCardComponent);